export const NotificationTypes = [
  "GEOFENCE_ENTERED",
  "GEOFENCE_EXITED",
  "DEVICE_FOUND",
];

export type NotificationType = typeof NotificationTypes[number];

export default interface PbNotification {
  userId: number;
  deviceId: string;
  type: NotificationType;
  message: string;
  id?: number;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
  metadata?: any;
}

export interface GeofenceMetadata {
  deviceId: string;
  geofenceId: string;
  geofenceName: string;
  timestamp: string;
  deviceLocation: {
    lat: number;
    lng: number;
  };
}

export const isNotification = (
  notification: any
): notification is PbNotification =>
  notification &&
  typeof notification === "object" &&
  Object.keys(notification).includes("userId") &&
  typeof notification["userId"] === "number" &&
  Object.keys(notification).includes("deviceId") &&
  typeof notification["deviceId"] === "string" &&
  Object.keys(notification).includes("type") &&
  NotificationTypes.includes(notification["type"]) &&
  Object.keys(notification).includes("message") &&
  typeof notification["message"] === "string";

export const isGeofenceMetadata = (
  metadata: any
): metadata is GeofenceMetadata =>
  metadata &&
  typeof metadata === "object" &&
  Object.keys(metadata).includes("deviceId") &&
  typeof metadata["deviceId"] === "string" &&
  Object.keys(metadata).includes("geofenceId") &&
  typeof metadata["geofenceId"] === "string" &&
  Object.keys(metadata).includes("geofenceName") &&
  typeof metadata["geofenceName"] === "string";
